var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7622 20.0002L27.7444 14.0178C27.9089 13.8531 27.9997 13.6334 28 13.3991C28 13.1647 27.9092 12.9447 27.7444 12.7803L27.2202 12.2562C27.0553 12.0911 26.8356 12.0007 26.6011 12.0007C26.367 12.0007 26.1473 12.0911 25.9824 12.2562L20.0003 18.2383L14.0178 12.2562C13.8533 12.0911 13.6334 12.0007 13.399 12.0007C13.1649 12.0007 12.945 12.0911 12.7805 12.2562L12.256 12.7803C11.9147 13.1216 11.9147 13.6768 12.256 14.0178L18.2383 20.0002L12.256 25.9824C12.0913 26.1473 12.0007 26.367 12.0007 26.6013C12.0007 26.8356 12.0913 27.0553 12.256 27.2201L12.7804 27.7442C12.9449 27.9092 13.1649 27.9997 13.3989 27.9997C13.6333 27.9997 13.8531 27.9092 14.0177 27.7442L20.0001 21.762L25.9823 27.7442C26.1471 27.9092 26.3668 27.9997 26.601 27.9997H26.6012C26.8355 27.9997 27.0552 27.9092 27.22 27.7442L27.7443 27.2201C27.9088 27.0554 27.9996 26.8356 27.9996 26.6013C27.9996 26.367 27.9088 26.1473 27.7443 25.9825L21.7622 20.0002Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.828bef17.svg";
export { ForwardRef as ReactComponent };